import React, { Component } from "react";
import PropTypes from "prop-types";
import "./styles/filterGroup.css";

class FilterGroup extends Component {
  state = {
    selectedFilters: [],
  };

  getClassName = (filter) => {
    const { size } = this.props;
    let defaultClass = `list-group-item filter-group-item ${
      size === "small" ? "small" : ""
    }`;
    if (this.state.selectedFilters.includes(filter))
      return defaultClass + " filter-group-item-active";
    return defaultClass;
  };

  handleClick = (filter) => (e) => {
    e.preventDefault();
    const { onChange } = this.props;
    let selectedFilters = [...this.state.selectedFilters];
    if (selectedFilters.includes(filter))
      selectedFilters = selectedFilters.filter((f) => f !== filter);
    else selectedFilters = [...selectedFilters, filter];
    this.setState({ selectedFilters }, () => onChange(selectedFilters));
  };

  render() {
    const { filters, className } = this.props;
    return (
      <ul className={`list-group list-group-horizontal ${className}`}>
        {filters &&
          filters.map((f, index) => (
            <li
              key={`filterGroupItemKey_${index}`}
              id={f}
              name={f}
              className={this.getClassName(f)}
              onClick={this.handleClick(f)}
            >
              {f}
            </li>
          ))}
      </ul>
    );
  }
}

FilterGroup.propTypes = {
  filters: PropTypes.array,
  disabledFilters: PropTypes.array,
  onChange: PropTypes.func,
};

export default FilterGroup;
